import { render, staticRenderFns } from "./Huizhou.vue?vue&type=template&id=3d248e39&scoped=true&"
import script from "./Huizhou.vue?vue&type=script&lang=js&"
export * from "./Huizhou.vue?vue&type=script&lang=js&"
import style0 from "./Huizhou.vue?vue&type=style&index=0&id=3d248e39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d248e39",
  null
  
)

export default component.exports